import serviceTwo from './serviceTwo';
import { UrlBuilder } from './url-builder';

export const createGroup = async (payload) => {
  const response = await serviceTwo.postTwo(`/groups/create-group`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const groupList = async () => {
  const response = await serviceTwo.getTwo(`/groups/list-groups`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateGroup = async (payload) => {
  const response = await serviceTwo.postTwo(`/groups/update-group`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const removeGroup = async (payload) => {
  const response = await serviceTwo.postTwo(`/groups/delete`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const listGroupMembers = async ({ page, pageSize, userType, companyId, groupType }) => {
  const builder = new UrlBuilder(`/groups/list-group-members`);

  const response = await serviceTwo.postTwo(builder.toString(), {
    page,
    pageSize,
    userType,
    companyId,
    groupType,
  });

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
